export default __webpack_public_path__ + "static/media/spoon.de94706f.png";